import React, { useState } from "react";
import { X, Check, XCircle, CheckCircle } from "lucide-react";
import apiService from "../services/api";
import "../styles/EmployeeApprovalModal.css";

const EmployeeApprovalModal = ({ newEmployees, onClose, onApproved }) => {
  const [employees, setEmployees] = useState(newEmployees || []);
  const [rejectingId, setRejectingId] = useState(null);
  const [rejectionReason, setRejectionReason] = useState("");
  const [loading, setLoading] = useState(false);

  const handleApprove = async (employeeId) => {
    setLoading(true);
    try {
      await apiService.approveNewEmployee(employeeId);
      setEmployees(employees.filter((emp) => emp.id !== employeeId));
      if (onApproved) onApproved();
    } catch (error) {
      console.error("Error approving employee:", error);
      alert("שגיאה באישור עובד");
    } finally {
      setLoading(false);
    }
  };

  const handleReject = async (employeeId) => {
    if (!rejectionReason.trim()) {
      alert("אנא הזן סיבת דחייה");
      return;
    }

    setLoading(true);
    try {
      await apiService.rejectNewEmployee(employeeId, rejectionReason);
      setEmployees(employees.filter((emp) => emp.id !== employeeId));
      setRejectingId(null);
      setRejectionReason("");
    } catch (error) {
      console.error("Error rejecting employee:", error);
      alert("שגיאה בדחיית עובד");
    } finally {
      setLoading(false);
    }
  };

  if (employees.length === 0) {
    return (
      <div className='modal-overlay' onClick={() => onClose()}>
        <div
          className='modal-content approval-modal'
          onClick={(e) => e.stopPropagation()}
        >
          <div className='modal-header'>
            <h2>✅ כל העובדים אושרו</h2>
            <button className='modal-close' onClick={() => onClose()}>
              <X size={24} />
            </button>
          </div>
          <div className='approval-empty'>
            <CheckCircle size={64} color='#10b981' />
            <p>אין עובדים חדשים להצגה</p>
            <button className='btn-primary' onClick={() => onClose()}>
              סגור
            </button>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className='modal-overlay' onClick={() => onClose()}>
      <div
        className='modal-content approval-modal'
        onClick={(e) => e.stopPropagation()}
      >
        <div className='modal-header'>
          <h2>עובדים חדשים להצגה ({employees.length})</h2>
          <button className='modal-close' onClick={() => onClose()}>
            <X size={24} />
          </button>
        </div>

        <div className='approval-list'>
          {employees.map((employee) => (
            <div key={employee.id} className='approval-item'>
              <div className='approval-item-header'>
                <h3>{employee.employee_name}</h3>
              </div>

              <div className='approval-item-details'>
                <div className='detail-row'>
                  <span className='label'>לקוח:</span>
                  <span className='value'>{employee.customer_name}</span>
                </div>
                <div className='detail-row'>
                  <span className='label'>סוג:</span>
                  <span className={`badge badge-${employee.type}`}>
                    {employee.type}
                  </span>
                </div>
                <div className='detail-row'>
                  <span className='label'>אמצעי תשלום:</span>
                  <span className='value'>{employee.payment_method}</span>
                </div>
                <div className='detail-row'>
                  <span className='label'>תעריף חול:</span>
                  <span className='value'>
                    ₪{employee.hour_rate || "לא צוין"}
                  </span>
                </div>
                <div className='detail-row'>
                  <span className='label'>תעריף סופ"ש:</span>
                  <span className='value'>
                    ₪{employee.weekend_hour_rate || "לא צוין"}
                  </span>
                </div>
              </div>

              {rejectingId === employee.id ? (
                <div className='rejection-form'>
                  <textarea
                    placeholder='סיבת דחייה...'
                    value={rejectionReason}
                    onChange={(e) => setRejectionReason(e.target.value)}
                    rows='3'
                  />
                  <div className='rejection-actions'>
                    <button
                      className='btn-danger'
                      onClick={() => handleReject(employee.id)}
                      disabled={loading}
                    >
                      אשר דחייה
                    </button>
                    <button
                      className='btn-secondary'
                      onClick={() => {
                        setRejectingId(null);
                        setRejectionReason("");
                      }}
                    >
                      ביטול
                    </button>
                  </div>
                </div>
              ) : (
                <div className='approval-item-actions'>
                  <button
                    className='btn-success'
                    onClick={() => handleApprove(employee.id)}
                    disabled={loading}
                  >
                    <Check size={18} />
                    אשר
                  </button>
                  <button
                    className='btn-danger'
                    onClick={() => setRejectingId(employee.id)}
                    disabled={loading}
                  >
                    <XCircle size={18} />
                    דחה
                  </button>
                </div>
              )}
            </div>
          ))}
        </div>

        <div className='modal-footer'>
          <button className='btn-secondary' onClick={() => onClose()}>
            סגור
          </button>
        </div>
      </div>
    </div>
  );
};

export default EmployeeApprovalModal;
